import { VerticalContainer } from "@shared/designSystem/Containers"
import { Text } from "@shared/designSystem/Texts"
import designSystemStyles from "@shared/styles/designSystemStyles"

interface DetailSectionProps {
    title: string
    children: React.ReactNode
    noPadding?: boolean
}

export const DetailSection: React.FC<DetailSectionProps> = ({ title, children, noPadding = false }) => (
    <VerticalContainer width="100%" gap={designSystemStyles.gapMd}>
        <Text text={`**${title.trim()}**`} markdown={true} color={designSystemStyles.colorText} />
        <VerticalContainer
            width="100%"
            gap={designSystemStyles.gapMd}
            backgroundColor={designSystemStyles.colorBackgroundGray2}
            borderRadius={designSystemStyles.cornerRadiusComponent}
            padding={noPadding ? undefined : designSystemStyles.paddingMd}
        >
            {children}
        </VerticalContainer>
    </VerticalContainer>
)

export default DetailSection
